import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../axiosInstance";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!email) {
      toast.warning(t("subscription_email_required"));
      return;
    }

    setLoading(true);

    try {
      const payload = { email };

      const response = await axiosInstance.post(
        "/api/v1/users/home/subscribe",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success(t("subscription_success"));
      setEmail("");
    } catch (error) {
      const serverMessage =
        error.response?.data?.message ||
        error.response?.data?.detail ||
        error.response?.data?.title;

      // معالجة خاصة للخطأ 415
      if (error.response?.status === 415) {
        toast.error(t("error_unsupported_media_type"));
      } else {
        toast.error(serverMessage || t("subscription_failed"));
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <footer className="text-center" dir={languageDirection}>
      <style>{`
      .partner-logo:hover img {
        filter: grayscale(0%);
        transform: scale(1.05);
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
      }

      .partner-logo {
        transition: all 0.3s ease;
      }

      .partner-logo img {
        transition: all 0.3s ease;
      }
        .sponsor-img {
          max-height: 80px;
          object-fit: contain;
          transition: transform 0.3s ease, filter 0.3s ease;
        }

        .sponsor-img:hover {
          transform: scale(1.1);
          filter: brightness(1.2);
        }
      `}</style>

      {/* الفوتر الأصلي */}
      <div className="bg-dark text-white py-5">
        <div className="container">
          <div className="row g-4">
            {/* شركاؤنا في النجاح */}
            <div
              className="container py-5"
              style={{
                position: "relative",
                backgroundImage:
                  "url('assets-v2/images/partners/al-yamamah.webp')",
                backgroundAttachment: "fixed",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              {/* طبقة شفافة خلف المحتوى */}
              <div
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  backgroundColor: "rgba(0, 0, 0, 0.3)", // تقليل الشفافية
                  zIndex: 0,
                }}
              ></div>

              <div className="row" style={{ zIndex: 1 }}>
                <div className="col-md-12 text-center mb-4" data-aos="fade-up">
                  <h5 className="mb-4 text-white">{t("success_partners")}</h5>
                  <div className="partners-container d-flex justify-content-center flex-wrap">
                    {[
                      {
                        name: "جامعة اليمامة",
                        href: "https://yu.edu.sa/?lang=ar",
                        img: "/assets-v2/images/partners/images.png",
                      },
                      {
                        name: "مركز الابتكار",
                        href: "https://yu.edu.sa/?lang=ar",
                        img: "/assets-v2/images/partners/image1.png",
                      },
                    ].map((partner, index) => (
                      <div
                        key={index}
                        className="partner-item mx-4"
                        data-aos="zoom-in"
                        data-aos-delay={index * 100}
                        style={{
                          transition:
                            "transform 0.3s ease, box-shadow 0.3s ease",
                          marginBottom: "30px",
                        }}
                      >
                        <a
                          href={partner.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-block"
                        >
                          <div
                            className="bg-white p-4 mx-auto shadow-sm"
                            style={{
                              width: "220px",
                              height: "140px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "12px",
                              border: "1px solid #ccc",
                              transition: "transform 0.3s ease",
                            }}
                          >
                            <img
                              src={partner.img}
                              alt={partner.name}
                              className="img-fluid"
                              style={{
                                maxWidth:
                                  partner.name === "مركز الابتكار"
                                    ? "140px"
                                    : "180px",
                                maxHeight:
                                  partner.name === "مركز الابتكار"
                                    ? "120px"
                                    : "100px",
                                transition: "transform 0.3s ease",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.transform =
                                  "scale(1.05)")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.transform = "scale(1)")
                              }
                            />
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* قسم الرعاة */}
            <div
              className="col-md-12 text-center"
              data-aos="fade-up"
              style={{
                background:
                  "linear-gradient(to bottom, rgba(0,0,0,0.9), rgba(50,50,50,0.7))",
                paddingTop: "50px",
                paddingBottom: "30px",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              }}
            >
              <h5 className="mb-4 text-white">{t("sponsors")}</h5>
              <div className="sponsors-container d-flex justify-content-center flex-wrap">
                {[
                  {
                    name: "شركة مفيد",
                    href: "https://mufeed.com/ar/",
                    img: "/assets-v2/images/sponsors/mufeed.jpg",
                  },
                  {
                    name: "شركة السويلم",
                    href: "https://swilem.com/",
                    img: "/assets-v2/images/sponsors/sy.png",
                  },
                ].map((sponsor, index) => (
                  <div
                    key={index}
                    className="sponsor-item mx-4"
                    data-aos="zoom-in"
                    data-aos-delay={index * 100}
                    style={{
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      marginBottom: "30px",
                    }}
                  >
                    <a
                      href={sponsor.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-block"
                    >
                      <div
                        className="bg-white p-4 mx-auto shadow-sm"
                        style={{
                          width: "220px",
                          height: "140px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "12px",
                          border: "1px solid #ccc",
                          transition: "transform 0.3s ease",
                        }}
                      >
                        <img
                          src={sponsor.img}
                          alt={sponsor.name}
                          className="img-fluid"
                          style={{
                            maxWidth: "180px",
                            maxHeight: "100px",
                            transition: "transform 0.3s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.05)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        />
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
            {/* الشعار والوصف والسوشيال ميديا */}
            <div className="col-lg-4 col-md-6">
              <img
                data-aos="fade-right"
                src="/assets-v2/images/logo/logo-removebg.png"
                alt={t("logo")}
                style={{
                  maxWidth: "50%",
                  height: "auto",
                  filter: "brightness(0) invert(1)",
                  // filter: "drop-shadow(0 0 6px white)"
                }}
                className="mb-4 mx-auto d-block"
              />

              <p
                className="mb-4 mx-auto d-block"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                {t("footer_description")}
              </p>
              <div className="d-flex justify-content-center gap-3">
                {/* X */}
                <a
                  href="https://x.com/mutahadithun?mx=2"
                  className="text-white fs-5"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <i className="fa-brands fa-x-twitter"> </i>
                </a>

                {/* Facebook */}
                <a
                  href="https://www.facebook.com/share/15umnQx72v/?mibextid=wwXIfr"
                  className="text-white fs-5"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-aos="fade-up"
                  data-aos-delay="250"
                >
                  <i className="fa-brands fa-facebook-f"></i>
                </a>

                {/* LinkedIn */}
                <a
                  href="https://www.linkedin.com/company/speakers-platform/posts/?feedView=all"
                  className="text-white fs-5"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>

            {/* روابط سريعة */}
            <div className="col-lg-2 col-md-6 col-6">
              <h5 className="fw-bold mb-4" data-aos="fade-up">
                {t("quick_links")}
              </h5>
              <ul className="list-unstyled mb-0">
                <li className="mb-2" data-aos="fade-up" data-aos-delay="100">
                  <a href="/" className="text-white text-decoration-none">
                    {t("home")}
                  </a>
                </li>
                <li className="mb-2" data-aos="fade-up" data-aos-delay="200">
                  <a
                    href="/speakers"
                    className="text-white text-decoration-none"
                  >
                    {t("speakers")}
                  </a>
                </li>
                <li className="mb-2" data-aos="fade-up" data-aos-delay="300">
                  <a href="/events" className="text-white text-decoration-none">
                    {t("events")}
                  </a>
                </li>
                <li className="mb-2" data-aos="fade-up" data-aos-delay="400">
                  <a href="/signup" className="text-white text-decoration-none">
                    {t("become_speaker")}
                  </a>
                </li>
                <li className="mb-2" data-aos="fade-up" data-aos-delay="500">
                  <a href="/about" className="text-white text-decoration-none">
                    {t("about")}
                  </a>
                </li>
                <li className="mb-2" data-aos="fade-up" data-aos-delay="600">
                  <a
                    href="/contact"
                    className="text-white text-decoration-none"
                  >
                    {t("contact")}
                  </a>
                </li>
              </ul>
            </div>

            {/* المواضيع */}
            <div className="col-lg-2 col-md-6 col-6">
              <h5 className="fw-bold mb-4" data-aos="fade-up">
                {t("topics")}
              </h5>
              <ul className="list-unstyled mb-0">
                {[
                  "topic_technology",
                  "topic_management",
                  "topic_leadership",
                  "topic_innovation",
                  "topic_personal_development",
                ].map((item, index) => (
                  <li
                    className="mb-2"
                    key={item}
                    data-aos="fade-up"
                    data-aos-delay={100 * (index + 1)}
                  >
                    <a
                      href="/speakers"
                      className="text-white text-decoration-none"
                    >
                      {t(item)}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* النشرة البريدية */}
            <div className="col-lg-4 col-md-6">
              <h5 className="fw-bold mb-4" data-aos="fade-left">
                {t("newsletter")}
              </h5>
              <p className="mb-4" data-aos="fade-up" data-aos-delay="100">
                {t("newsletter_description")}
              </p>
              <div
                className="input-group mb-3"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <input
                  type="email"
                  className="form-control"
                  placeholder={t("your_email")}
                  aria-label={t("your_email")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button
                  className="btn btn-outline-light"
                  type="button"
                  onClick={handleClick}
                >
                  {t("subscribe")}
                </button>
              </div>
            </div>
          </div>

          <hr className="my-4 bg-secondary" data-aos="fade-up" />
          <div className="row align-items-center">
            <div
              className="col-md-6 text-center text-md-start"
              data-aos="fade-up"
            >
              <p className="mb-0">
                © 2025 {t("Speaker")}. {t("copyright")}
              </p>
              <p className="small mt-2">
                {i18n.language === "ar"
                  ? "™ متحدثون علامة تجارية مسجلة لدى الهيئة السعودية للملكية الفكرية."
                  : "™ Mutahadithun is a registered trademark with the Saudi Authority for Intellectual Property."}
              </p>
            </div>
            <div
              className="col-md-6 text-center text-md-end mt-3 mt-md-0"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <ul className="list-inline mb-0">
                <li className="list-inline-item">
                  <a
                    href="/privacy"
                    className="text-white text-decoration-none small"
                  >
                    {t("privacy_policy")}
                  </a>
                </li>
                <li className="list-inline-item mx-3">
                  <a
                    href="/terms"
                    className="text-white text-decoration-none small"
                  >
                    {t("terms_conditions")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="200">
            <a
              href="https://www.credential.net/5f5c7f28-4129-4d13-8691-d3e083a80b35#acc.AgCv2rqi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/assets-v2/images/certificate.png"
                alt="شهادة مالك الموقع"
                className="img-fluid"
                style={{
                  maxWidth: "200px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
